import { useEffect, useState } from "react";

export const ColumnPicker = ({
  options,
  visibleColumns,
  onToggle,
  onReset,
  onSelectAll,
  triggerLabel = "Manage columns",
  triggerClassName = "inline-flex items-center gap-2 rounded-md bg-gray-100 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200",
  panelClassName = "w-80",
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const close = (event) => {
      if (!event.target.closest?.("[data-column-picker]")) setOpen(false);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [open]);

  return (
    <div className="relative" data-column-picker>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className={triggerClassName}
      >
        {triggerLabel}
      </button>
      {open && (
        <div
          className={`absolute right-0 z-30 mt-2 rounded-lg border border-gray-200 bg-white shadow-lg ${panelClassName}`}
        >
          <div className="flex items-center justify-between border-b border-gray-200 px-3 py-2">
            <span className="text-sm font-semibold text-gray-700">Visible columns</span>
            <div className="flex items-center gap-2">
              <button
                type="button"
                className="text-xs text-blue-600 hover:underline"
                onClick={onSelectAll}
              >
                All
              </button>
              <button
                type="button"
                className="text-xs text-blue-600 hover:underline"
                onClick={onReset}
              >
                Default
              </button>
            </div>
          </div>
          <div className="max-h-72 overflow-y-auto py-2">
            {options.map((option) => (
              <label
                key={option.id}
                className="flex items-center gap-2 px-3 py-1 text-sm text-gray-700 hover:bg-gray-50"
              >
                <input
                  type="checkbox"
                  checked={visibleColumns.includes(option.id)}
                  onChange={() => onToggle(option.id)}
                  className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                <span className="truncate" title={option.label}>
                  {option.label}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
